//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import TabPanel from "../Reusable/Tab";
import EditReceiveManifest from "./EditReceiveManifest";

const SwitchTab = (props: any) => {
  const {
    handleEdit,
    isLoading,
    data,
    id,
    handlePrint,
    isPrintLoading,
    handlecheckConsignments,
  } = props;

  return (
    <>
      <TabPanel
        tabTitle={["Update", "Documents"]}
        tabPanels={[
          <>
            <EditReceiveManifest
              handleEdit={handleEdit}
              isLoading={isLoading}
              data={data}
              handlePrint={handlePrint}
              isPrintLoading={isPrintLoading}
              handlecheckConsignments={handlecheckConsignments}
            />
          </>,
          <>
            <FileUpload object_id={id} />
          </>,
        ]}
      />
    </>
  );
};

export default SwitchTab;
